export const LOGIN_PENDING = "LOGIN_PENDING";
export const LOGIN_SUCCESS = "LOGIN_SUCCES";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_PENDING = "REGISTER_PENDING";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const UPDATE_PROFILE_PENDING = "UPDATE_PROFILE_PENDING";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const CHANGE_PASSWORD_PENDING = "CHANGE_PASSWORD_PENDING";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const LOGOUT = "LOGOUT";

export const GET_EXAMPLE_VENUE_BEGIN = "GET_EXAMPLE_VENUE_BEGIN";
export const GET_EXAMPLE_VENUE_SUCCESS = "GET_EXAMPLE_VENUE_SUCCESS";
export const GET_EXAMPLE_VENUE_FAIL = "GET_EXAMPLE_VENUE_FAIL";

export const GET_EXAMPLE_VENDOR_BEGIN = "GET_EXAMPLE_VENDOR_BEGIN";
export const GET_EXAMPLE_VENDOR_SUCCESS = "GET_EXAMPLE_VENDOR_SUCCESS";
export const GET_EXAMPLE_VENDOR_FAIL = "GET_EXAMPLE_VENDOR_FAIL";

export const GET_EXAMPLE_PACKAGES_BEGIN = "GET_EXAMPLE_PACKAGES_BEGIN";
export const GET_EXAMPLE_PACKAGES_SUCCESS = "GET_EXAMPLE_PACKAGES_SUCCESS";
export const GET_EXAMPLE_PACKAGES_FAIL = "GET_EXAMPLE_PACKAGES_FAIL";

export const GET_EXAMPLE_ORGANIZER_BEGIN = "GET_EXAMPLE_ORGANIZER_BEGIN";
export const GET_EXAMPLE_ORGANIZER_SUCCESS = "GET_EXAMPLE_ORGANIZER_SUCCESS";
export const GET_EXAMPLE_ORGANIZER_FAIL = "GET_EXAMPLE_ORGANIZER_FAIL";

export const GET_SEARCH_VENUE_BEGIN = "GET_SEARCH_VENUE_BEGIN";
export const GET_SEARCH_VENUE_SUCCESS = "GET_SEARCH_VENUE_SUCCESS";
export const GET_SEARCH_VENUE_FAIL = "GET_SEARCH_VENUE_FAIL";

export const GET_SEARCH_PACKAGES_BEGIN = "GET_SEARCH_PACKAGES_BEGIN";
export const GET_SEARCH_PACKAGES_SUCCESS = "GET_SEARCH_PACKAGES_SUCCESS";
export const GET_SEARCH_PACKAGES_FAIL = "GET_SEARCH_PACKAGES_FAIL";

export const GET_SEARCH_ORGANIZER_BEGIN = "GET_SEARCH_ORGANIZER_BEGIN";
export const GET_SEARCH_ORGANIZER_SUCCESS = "GET_SEARCH_ORGANIZER_SUCCESS";
export const GET_SEARCH_ORGANIZER_FAIL = "GET_SEARCH_ORGANIZER_FAIL";

export const GET_QUOTATION_INBOX_BEGIN = "GET_QUOTATION_INBOX_BEGIN";
export const GET_QUOTATION_INBOX_SUCCESS = "GET_QUOTATION_INBOX_SUCCESS";
export const GET_QUOTATION_INBOX_FAIL = "GET_QUOTATION_INBOX_FAIL";

export const GET_QUOTATION_SENT_BEGIN = "GET_QUOTATION_SENT_BEGIN";
export const GET_QUOTATION_SENT_SUCCESS = "GET_QUOTATION_SENT_SUCCESS";
export const GET_QUOTATION_SENT_FAIL = "GET_QUOTATION_SENT_FAIL";

export const GET_VENDOR_BEGIN = "GET_VENDOR_BEGIN";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAIL = "GET_VENDOR_FAIL";

export const GET_SEARCH_BEGIN = "GET_SEARCH_BEGIN";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";
export const GET_SEARCH_FAIL = "GET_SEARCH_FAIL";
export const GET_DETAIL_VENDOR_BEGIN = "GET_DETAIL_VENDOR_BEGIN";
export const GET_DETAIL_VENDOR_SUCCESS = "GET_DETAIL_VENDOR_SUCCESS";
export const GET_DETAIL_VENDOR_FAIL = "GET_DETAIL_VENDOR_FAIL";

export const GET_DETAIL_PACKAGE_BEGIN = "GET_DETAIL_PACKAGE_BEGIN";
export const GET_DETAIL_PACKAGE_SUCCESS = "GET_DETAIL_PACKAGE_SUCCESS";
export const GET_DETAIL_PACKAGE_FAIL = "GET_DETAIL_PACKAGE_FAIL";

export const GET_CONFIG_LOCATION_BEGIN = "GET_CONFIG_LOCATION_BEGIN";
export const GET_CONFIG_LOCATION_SUCCESS = "GET_CONFIG_LOCATION_SUCCESS";
export const GET_CONFIG_LOCATION_FAIL = "GET_CONFIG_LOCATION_FAIL";

export const POST_REQUEST_USER_BEGIN = "POST_REQUEST_USER_BEGIN";
export const POST_REQUEST_USER_SUCCESS = "POST_REQUEST_USER_SUCCESS";
export const POST_REQUEST_USER_FAIL = " POST_REQUEST_USER_FAIL";

export const GET_REQUEST_BEGIN = " GET_REQUEST_BEGIN";
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_FAIL = "GET_REQUEST_FAIL";

export const GET_QUOTATION_SENT_DETAIL_BEGIN =
  "GET_QUOTATION_SENT_DETAIL_BEGIN";
export const GET_QUOTATION_SENT_DETAIL_SUCCESS =
  "GET_QUOTATION_SENT_DETAIL_SUCCESS";
export const GET_QUOTATION_SENT_DETAIL_FAIL = "GET_QUOTATION_SENT_DETAIL_FAIL";

export const GET_QUOTATION_INBOX_DETAIL_BEGIN =
  "GET_QUOTATION_INBOX_DETAIL_BEGIN";
export const GET_QUOTATION_INBOX_DETAIL_SUCCESS =
  "GET_QUOTATION_INBOX_DETAIL_SUCCESS";
export const GET_QUOTATION_INBOX_DETAIL_FAIL =
  "GET_QUOTATION_INBOX_DETAIL_FAIL";

export const GET_NOTIFICATION_USER_BEGIN = "GET_NOTIFICATION_USER_BEGIN";
export const GET_NOTIFICATION_USER_SUCCESS = "GET_NOTIFICATION_USER_SUCCESS";
export const GET_NOTIFICATION_USER_FAIL = "GET_NOTIFICATION_USER_FAIL";

export const GET_OAUTH_BEGIN = "GET_OAUTH_BEGIN";
export const GET_OAUTH_SUCCESS = "GET_OAUTH_SUCCESS";
export const GET_OAUTH_FAIL = "GET_OAUTH_FAIL";

export const UPDATE_NOTIFICATION_BEGIN = "UPDATE_NOTIFICATION_BEGIN";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL";
// export const GET_NOTIFICATION_DETAIL_BEGIN = "GET_NOTIFICATION_DETAIL_BEGIN";
// export const GET_NOTIFICATION_DETAIL_SUCCESS =
//   "GET_NOTIFICATION_DETAIL_SUCCESS";
// export const GET_NOTIFICATION_DETAIL_FAIL = "GET_NOTIFICATION_DETAIL_FAIL";
